import { API_ENDPOINTS } from '../config/api.config';
import httpService from './http.service';

class DocumentService {
  // Uploader un document avec rattachement au projet
  async uploadDocument(file, projectId, name) {
    try {
      console.log('Upload du document:', file.name, 'pour le projet:', projectId);
      
      const formData = new FormData();
      formData.append('file', file);
      formData.append('name', name || file.name);
      if (projectId) {
        formData.append('projet', projectId);
      }
      
      const response = await httpService.uploadFile(API_ENDPOINTS.DOCUMENTS.UPLOAD, formData);
      
      console.log('Document uploadé avec succès:', response);
      return {
        success: true,
        data: response,
        documentId: response.id,
      };
    } catch (error) {
      console.error('Erreur lors de l\'upload du document:', error);
      return {
        success: false,
        error: error.message || 'Erreur lors de l\'upload du document',
      };
    }
  }

  // Uploader plusieurs documents avec rattachement au projet
  async uploadDocuments(files, projectId) {
    try {
      console.log('Upload de plusieurs documents:', files.length, 'pour le projet:', projectId);
      
      const uploadPromises = files.map(file => this.uploadDocument(file, projectId));
      const results = await Promise.all(uploadPromises);
      
      const successfulUploads = results.filter(result => result.success);
      const failedUploads = results.filter(result => !result.success);
      
      console.log('Résultats de l\'upload:', {
        successful: successfulUploads.length,
        failed: failedUploads.length
      });
      
      return {
        success: failedUploads.length === 0,
        data: successfulUploads.map(result => result.documentId),
        errors: failedUploads.map(result => result.error),
      };
    } catch (error) {
      console.error('Erreur lors de l\'upload des documents:', error);
      return {
        success: false,
        error: error.message || 'Erreur lors de l\'upload des documents',
      };
    }
  }

  // Récupérer la liste des documents
  async getDocuments(params = {}) {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const endpoint = `${API_ENDPOINTS.DOCUMENTS.LIST}${queryParams ? `?${queryParams}` : ''}`;
      
      const response = await httpService.get(endpoint);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error('Erreur lors de la récupération des documents:', error);
      return {
        success: false,
        error: error.message,
      };
    }
  }

  // Récupérer un document par ID
  async getDocumentById(documentId) {
    try {
      const response = await httpService.get(API_ENDPOINTS.DOCUMENTS.DETAIL(documentId));
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error(`Erreur lors de la récupération du document ${documentId}:`, error);
      return {
        success: false,
        error: error.message,
      };
    }
  }
}

// Instance singleton
export const documentService = new DocumentService();
export default documentService;